function Cxl({ children, className }) {
  return <div className={`d-flex flex-column ${className}`}>{children}</div>;
}

export default Cxl;